module.exports = __webpack_public_path__ + "7327489d33c81abce77f70c3a4e45014.svg";